import React, {useState, useEffect} from 'react'
import { CircularProgress } from '@material-ui/core';
import axios from "axios";
import DeviceMap from "./DeviceMap/DeviceMap"
import Tooltip from "@material-ui/core/Tooltip";
import UpdateIcon from '@mui/icons-material/Update';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import * as S from './styles';

function DeviceScan(props) {

    let {legal_person} = props
    const { t } = useTranslation()

    const [deviceScan, setDeviceScan] = useState(null);
    const [sdkMetadata, setSdkMetadata] = useState(null);

    const androidIcon = (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.9751 3.019L15.9351 1.28703C15.9474 1.26483 15.9552 1.24044 15.958 1.21524C15.9609 1.19003 15.9588 1.16452 15.9517 1.14014C15.9447 1.11577 15.933 1.09301 15.9172 1.07317C15.9014 1.05334 15.8818 1.03681 15.8596 1.02453C15.8374 1.01225 15.813 1.00446 15.7878 1.00161C15.7626 0.998761 15.7371 1.0009 15.7127 1.00791C15.6884 1.01492 15.6656 1.02667 15.6458 1.04247C15.6259 1.05828 15.6094 1.07783 15.5971 1.10003L14.6271 2.85003C13.7991 2.48692 12.9048 2.29944 12.0006 2.29944C11.0965 2.29944 10.2022 2.48692 9.37413 2.85003L8.40413 1.10003C8.37933 1.05494 8.33763 1.02155 8.28822 1.00721C8.2388 0.992859 8.18571 0.99873 8.14063 1.02353C8.09554 1.04833 8.06215 1.09002 8.0478 1.13943C8.03346 1.18885 8.03933 1.24194 8.06413 1.28703L9.02413 3.01903C8.111 3.46988 7.33952 4.16328 6.79415 5.0233C6.24879 5.88333 5.95056 6.87683 5.93213 7.89503H18.0691C18.0505 6.87662 17.752 5.88297 17.2062 5.02293C16.6605 4.16288 15.8886 3.4696 14.9751 3.01903ZM9.20013 5.67403C9.09981 5.67403 9.00175 5.64427 8.91835 5.58851C8.83495 5.53276 8.76997 5.45352 8.73162 5.36082C8.69328 5.26812 8.6833 5.16612 8.70294 5.06775C8.72259 4.96937 8.77097 4.87904 8.84198 4.80817C8.91298 4.73731 9.00341 4.6891 9.10183 4.66965C9.20024 4.6502 9.30222 4.66038 9.39484 4.69891C9.48746 4.73744 9.56658 4.80257 9.62217 4.88608C9.67776 4.96959 9.70732 5.06771 9.70713 5.16803C9.70686 5.30232 9.65333 5.43102 9.55828 5.52589C9.46322 5.62075 9.33442 5.67403 9.20013 5.67403ZM14.8021 5.67403C14.7018 5.67403 14.6037 5.64427 14.5203 5.58851C14.437 5.53276 14.372 5.45352 14.3336 5.36082C14.2953 5.26812 14.2853 5.16612 14.3049 5.06775C14.3246 4.96937 14.373 4.87904 14.444 4.80817C14.515 4.73731 14.6054 4.6891 14.7038 4.66965C14.8022 4.6502 14.9042 4.66038 14.9968 4.69891C15.0895 4.73744 15.1686 4.80257 15.2242 4.88608C15.2798 4.96959 15.3093 5.06771 15.3091 5.16803C15.3089 5.30232 15.2553 5.43102 15.1603 5.52589C15.0652 5.62075 14.9364 5.67403 14.8021 5.67403ZM5.93013 17.171C5.92986 17.3641 5.96771 17.5553 6.04151 17.7337C6.1153 17.9121 6.22358 18.0742 6.36015 18.2107C6.49672 18.3472 6.65888 18.4554 6.83734 18.529C7.01581 18.6027 7.20706 18.6404 7.40013 18.64H8.37313V21.64C8.37313 22.0009 8.51646 22.3469 8.77161 22.602C9.02675 22.8572 9.3728 23.0005 9.73362 23.0005C10.0945 23.0005 10.4405 22.8572 10.6956 22.602C10.9508 22.3469 11.0941 22.0009 11.0941 21.64V18.64H12.9081V21.64C12.9081 22.0007 13.0514 22.3466 13.3065 22.6017C13.5615 22.8567 13.9074 23 14.2681 23C14.6288 23 14.9747 22.8567 15.2298 22.6017C15.4848 22.3466 15.6281 22.0007 15.6281 21.64V18.64H16.6021C16.7949 18.6402 16.9859 18.6023 17.1641 18.5286C17.3422 18.4548 17.5041 18.3467 17.6405 18.2104C17.7768 18.074 17.8849 17.9121 17.9586 17.734C18.0324 17.5558 18.0703 17.3648 18.0701 17.172V8.37503H5.93013V17.171ZM4.06313 8.14103C3.88444 8.14103 3.70751 8.17624 3.54244 8.24465C3.37738 8.31306 3.22741 8.41332 3.10111 8.53972C2.97481 8.66611 2.87465 8.81615 2.80636 8.98127C2.73807 9.14639 2.70299 9.32335 2.70313 9.50203V15.171C2.70313 15.3496 2.7383 15.5265 2.80665 15.6915C2.875 15.8565 2.97517 16.0064 3.10146 16.1327C3.22775 16.259 3.37767 16.3592 3.54268 16.4275C3.70768 16.4959 3.88453 16.531 4.06313 16.531C4.24172 16.531 4.41857 16.4959 4.58357 16.4275C4.74858 16.3592 4.8985 16.259 5.02479 16.1327C5.15108 16.0064 5.25126 15.8565 5.3196 15.6915C5.38795 15.5265 5.42313 15.3496 5.42313 15.171V9.50203C5.42313 9.32343 5.38795 9.14658 5.3196 8.98158C5.25126 8.81658 5.15108 8.66665 5.02479 8.54036C4.8985 8.41408 4.74858 8.3139 4.58357 8.24555C4.41857 8.17721 4.24172 8.14203 4.06313 8.14203M19.9351 8.14203C19.7564 8.14203 19.5795 8.17724 19.4144 8.24565C19.2494 8.31406 19.0994 8.41432 18.9731 8.54072C18.8468 8.66711 18.7466 8.81715 18.6784 8.98227C18.6101 9.14739 18.575 9.32435 18.5751 9.50303V15.172C18.5751 15.3506 18.6103 15.5275 18.6786 15.6925C18.747 15.8575 18.8472 16.0074 18.9735 16.1337C19.0997 16.26 19.2497 16.3602 19.4147 16.4285C19.5797 16.4969 19.7565 16.532 19.9351 16.532C20.1137 16.532 20.2906 16.4969 20.4556 16.4285C20.6206 16.3602 20.7705 16.26 20.8968 16.1337C21.0231 16.0074 21.1233 15.8575 21.1916 15.6925C21.2599 15.5275 21.2951 15.3506 21.2951 15.172V9.50203C21.2951 9.14133 21.1518 8.79541 20.8968 8.54036C20.6417 8.28531 20.2958 8.14203 19.9351 8.14203Z" fill="#4ECB71"/>
        </svg>
    )

    const appleIcon = (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.0502 20.28C16.0702 21.23 15.0002 21.08 13.9702 20.63C12.8802 20.17 11.8802 20.15 10.7302 20.63C9.29016 21.25 8.53016 21.07 7.67016 20.28C2.79016 15.25 3.51016 7.59 9.05016 7.31C10.4002 7.38 11.3402 8.05 12.1302 8.11C13.3102 7.87 14.4402 7.18 15.7002 7.27C17.2102 7.39 18.3502 7.99 19.1002 9.07C15.9802 10.94 16.7202 15.05 19.5802 16.2C19.0102 17.7 18.2702 19.19 17.0402 20.29L17.0502 20.28ZM12.0302 7.25C11.8802 5.02 13.6902 3.18 15.7702 3C16.0602 5.58 13.4302 7.5 12.0302 7.25Z" fill="#545454"/>
        </svg>
    )

    const webIcon = (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14M14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.9512 17.6683 16.4141 18.932 14.59 19.56ZM14.34 14H9.66C9.56 13.34 9.5 12.68 9.5 12C9.5 11.32 9.56 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM12 19.96C11.17 18.76 10.5 17.43 10.09 16H13.91C13.5 17.43 12.83 18.76 12 19.96ZM8 8H5.08C6.03864 6.32703 7.57466 5.06124 9.4 4.44C8.8 5.55 8.35 6.75 8 8ZM5.08 16H8C8.35 17.25 8.8 18.45 9.4 19.56C7.57827 18.9323 6.04429 17.6682 5.08 16ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14M12 4.03C12.83 5.23 13.5 6.57 13.91 8H10.09C10.5 6.57 11.17 5.23 12 4.03ZM18.92 8H15.97C15.6565 6.76161 15.1931 5.56611 14.59 4.44C16.43 5.07 17.96 6.34 18.92 8ZM12 2C6.47 2 2 6.5 2 12C2 14.6522 3.05357 17.1957 4.92893 19.0711C5.85752 19.9997 6.95991 20.7362 8.17317 21.2388C9.38642 21.7413 10.6868 22 12 22C14.6522 22 17.1957 20.9464 19.0711 19.0711C20.9464 17.1957 22 14.6522 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z" fill="#545454"/>
        </svg>
    )

    const TORDescription  = 'A rede TOR é usada para anonimizar o tráfego, o que pode indicar uma tentativa de ocultar atividades suspeitas. Ela aumenta riscos de segurança associados ao dispositivo.'
    const VPNDescription  = 'VPNs são usadas para mascarar a localização e proteger a privacidade, mas também podem ser usadas para ocultar atividades suspeitas. Seu uso pode apresentar riscos de segurança.'
    const CallDescription = 'Um dispositivo em chamada ativa pode indicar riscos de segurança ao usuário, relacionados a golpe via telefone.'

    const getPlatformData = (channel, platform, version) => {
        let translatedChannel = channel;
        if (channel === 'app') {
            translatedChannel = "Aplicativo";
        } else if (channel === 'internet_banking') {
            translatedChannel = 'Internet Banking';
        }

        let translatedPlatform = platform;
        let logo = null;
        if (platform === 'android') {
            translatedPlatform = 'Android';
            logo = androidIcon;
        } else if (platform === 'ios') {
            translatedPlatform = 'iOS';
            logo = appleIcon;
        } else if (platform === 'web') {
            translatedPlatform = 'Web'
            logo = webIcon;
        }

        return (
            <S.PlatformContainer>
                {logo}
                <S.PlatformText>
                    {translatedPlatform} com acesso via {translatedChannel} {version ? `- SDK ${version}` : ''}
                </S.PlatformText>
            </S.PlatformContainer>
        )
    }

    const versionWarning = (platform, version, latest_data) => {
        if (!latest_data) return <></>
        if (!version) {
            return <></>
        }
        if ((version || '').replace(/[a-zA-Z]/g, '') !== (latest_data[platform].version || '').replace(/[a-zA-Z]/g, '')) {
            return (
                <S.VersionWarning>
                    <UpdateIcon style={{width: '24px', height: '24px', color: "#a60505"}} />
                    <S.WarningInfoWrapper>
                        <S.WarningTitle>Essa análise foi feita com um versão desatualizada da SDK</S.WarningTitle>
                        <S.WarningText>Essa análise foi feita com a versão <S.Version>{platform} {version}</S.Version> da SDK. Atualize para a versão <S.Version>{platform} {latest_data[platform].version}</S.Version> para poder utilizar as novas funcionalidades e melhorias de performance e segurança.</S.WarningText>
                        <S.WarningFooting>Dúvidas para atualizar? Acesse a <a href={latest_data[platform].documentation ?? ''}>documentação da SDK.</a></S.WarningFooting>
                        <S.WarningFooting>Versão mais recente lançada em {moment(latest_data[platform].release_date).format("DD/MM/YYYY")}</S.WarningFooting>

                    </S.WarningInfoWrapper>
                </S.VersionWarning>
            )
        }
        return <></>
    }

    const retrieveCoordinates = (source) => {

        if (!source || !Array.isArray(source.coordinates) || source.coordinates.length < 2) {
            return {latitude: 'Indisponível', longitude: 'Indisponível'};
        }
        const coordinates = {latitude: source.coordinates[0].toString().substring(0, 8), longitude: source.coordinates[1].toString().substring(0, 8)}
        console.log(coordinates)
        return coordinates
    }

    const [IPCoordinates, setIPCoordinates] = useState({latitude: 'Indisponível', longitude: 'Indisponível'});
    const [GPSCoordinates, setGPSCoordinates] = useState({latitude: 'Indisponível', longitude: 'Indisponível'});

    const formatModelName = (device_data) => {

        let translatedPlatform = ''
        if (deviceScan.platform === 'android') {
            translatedPlatform = 'Android';
        } else if (deviceScan.platform === 'ios') {
            translatedPlatform = 'iOS';
        } else if (deviceScan.platform === 'web') {
            translatedPlatform = 'Web'
        }

        if (device_data.model && device_data.system_version) {
            return device_data.model + ' - ' + translatedPlatform + ' v' + device_data.system_version;
        }
        if (device_data.model) {
            return device_data.model;
        }
        if (device_data.system_version) {
            return 'Versão ' + device_data.system_version;
        }
        return 'Indisponível';
    }

    useEffect(() => {
    const timer = setTimeout(() => {
        let requestHeaders = { headers:{'company_key': legal_person.company_key}}
        axios.get('/dash/device_scan/session/' + legal_person.source.session_id, requestHeaders).then( response => {
            setDeviceScan(response.data);
            setIPCoordinates(retrieveCoordinates(response.data.ip_data));
            setGPSCoordinates(retrieveCoordinates(response.data.gps_data));

        }).catch(error => {
            setDeviceScan(undefined)
        })
    }, 500);
    return () => {
        clearTimeout(timer)
    }
}, [legal_person])

    useEffect(() => {
        axios.get('/dash/device_scan/sdk/metadata').then(response => {
            setSdkMetadata(response.data);
        })
    }, [legal_person])

    if (deviceScan === null) {
        return (
            <div className="analysisCard" style={{minHeight: "250px"}}>
                <div className={["blueText", "subtitleSize"].join(" ")}>
                {t("device_scan")}
                </div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <CircularProgress style={{margin:"auto"}} />
                </div>
            </div>
        );    
    }
    else if (deviceScan === undefined){
        return (
            <div className="analysisCard" style={{minHeight: "250px"}}>
                <div className={["blueText", "subtitleSize"].join(" ")}>Device Scan</div>
                <div style={{display:"flex", flexGrow:"1"}}>
                    <div className={["labelText", "normalMediumSize"].join(" ")} style={{margin:"auto"}}>
                    {t("information_unavailable")}
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className="analysisCard">
            <div className={["blueText", "subtitleSize"].join(" ")}>
                {t("device_scan")}
            </div>
            <div className="internalCardContainer">
                <DeviceMap device_scan={deviceScan}/>
            </div>
            {getPlatformData((legal_person.source || {}).channel, deviceScan.platform, deviceScan.sdk_version)}
            {versionWarning(deviceScan.platform, deviceScan.sdk_version, sdkMetadata)}
            <div className="internalCardContainer"  style={{display: "flex", flexDirection: "row", gap: "16px"}}>
                <S.Column style={{width: '100%'}}>
                    <S.Subtitle>Dados do dispositivo</S.Subtitle>
                    <S.Tab>
                        <S.Line>
                            <S.Label>• Modelo:</S.Label>
                            <S.Content>{formatModelName(deviceScan.device_data)}</S.Content>
                        </S.Line>
                        {deviceScan.platform === 'ios' &&
                            <S.Line>
                                <S.Label>• Comportamento suspeito:</S.Label>
                                <S.Indicator category={!deviceScan.device_data?.is_tampered}>{deviceScan.device_data?.is_tampered ? 'Detectado' : 'Não Detectado'}</S.Indicator>
                            </S.Line>
                        }
                        {deviceScan.platform === 'android' &&
                            <S.Line>
                                <S.Label>• Root:</S.Label>
                                <S.Indicator category={!deviceScan.device_data?.is_rooted}>{deviceScan.device_data?.is_rooted ? 'Detectado' : 'Não Detectado'}</S.Indicator>
                            </S.Line>
                        }
                        <S.Line>
                            <S.Label>• Emulador:</S.Label>
                            <S.Indicator category={!deviceScan.device_data?.is_emulator}>{deviceScan.device_data?.is_emulator ? 'Detectado' : 'Não Detectado'}</S.Indicator>
                        </S.Line>
                    </S.Tab>
                </S.Column>
            </div>
            <div className="internalCardContainer"  style={{ flexDirection: "row", display: 'flex', justifyContent: 'space-between'}}>
                <S.Column>
                    <S.Subtitle>Dados de IP</S.Subtitle>
                    <S.Tab>
                        <S.Line>
                            <S.Label>• Endereço:</S.Label>
                            <S.Content>{(deviceScan.ip_data || {}).ip ?? 'Indisponível'}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• País:</S.Label>
                            <S.Content>{(deviceScan.ip_data || {}).country_code ? t((deviceScan.ip_data || {}).country_code) : 'Indisponível'}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• Latitude:</S.Label>
                            <S.Content>{IPCoordinates.latitude}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• Longitude:</S.Label>
                            <S.Content>{IPCoordinates.longitude}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• Rede Móvel:</S.Label>
                            <S.Content>{deviceScan.ip_data?.is_from_mobile_network ? 'Sim' : 'Não'}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• IP TOR:</S.Label>
                            <Tooltip placement="right" title={<div className='tooltipText'>{TORDescription}</div>}>
                                <S.Indicator category={!deviceScan.ip_data?.tor_flag}>{deviceScan.ip_data?.tor_flag ? 'Detectado' : 'Não detectado'}</S.Indicator>
                            </Tooltip>
                        </S.Line>
                        <S.Line>
                            <S.Label>• IP VPN:</S.Label>
                            <Tooltip placement="right" title={<div className='tooltipText'>{VPNDescription}</div>}>
                                <S.Indicator category={!deviceScan.ip_data?.vpn_flag}>{deviceScan.ip_data?.vpn_flag ? 'Detectado' : 'Não detectado'}</S.Indicator>
                            </Tooltip>
                        </S.Line>
                    </S.Tab>
                </S.Column>
                <S.Divider/>
                <S.Column>
                    <S.Subtitle>Dados de GPS</S.Subtitle>
                    <S.Tab>
                        <S.Line>
                            <S.Label>• Latitude:</S.Label>
                            <S.Content>{GPSCoordinates.latitude}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• Longitude:</S.Label>
                            <S.Content>{GPSCoordinates.longitude}</S.Content>
                        </S.Line>
                        <S.Line>
                            <S.Label>• GPS Falso:</S.Label>
                            <S.Indicator category={!deviceScan.gps_data?.tor_flag}>{deviceScan.gps_data?.is_fake_gps ? 'Detectado' : 'Não detectado'}</S.Indicator>
                        </S.Line>
                    </S.Tab>
                    <S.Subtitle>Dados de telefonia</S.Subtitle>
                    <S.Tab>
                        <S.Line>
                            <S.Label>• Em chamada:</S.Label>
                            <Tooltip placement="right" title={<div className='tooltipText'>{CallDescription}</div>}>
                                <S.Indicator category={!deviceScan.telephony_data?.is_in_call}>{deviceScan.telephony_data?.is_in_call ? 'Sim' : 'Não'}</S.Indicator>
                            </Tooltip>
                        </S.Line>
                    </S.Tab>
                </S.Column>
            </div>
        </div>  
    )
}

export default DeviceScan